var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavIcon4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 1650,
    width: 1500,
    viewBox: "-19.2 -41 166.4 246",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(.7 1.42855)",
    id: "a",
    y2: 71.546,
    x2: 18.887,
    y1: 71.546,
    x1: 188.253
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "40.9%",
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "77.5%",
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(.79413 1.25924)",
    id: "b",
    y2: 107.562,
    x2: -27.559,
    y1: 31.439,
    x1: 93.148
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".7%",
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "26%",
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "51.2%",
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76%",
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(1.04684 .95525)",
    id: "c",
    y2: 33.764,
    x2: 58.646,
    y1: -27.356,
    x1: 2.873
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "6.9%",
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "47.6%",
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80.1%",
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "scale(1.34381 .74415)",
    id: "d",
    y2: 349.947,
    x2: -20.245,
    y1: 174.243,
    x1: 77.053
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C31162"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.2 103.22l49.8 49.8V51.39l-49.8 49.8z",
    fillRule: "nonzero",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "url(#b)",
    d: "M78.2 101.19L17 40H9.95C4.45 40 0 44.22 0 49.72V84.9c0 3.55 2.88 6.43 6.43 6.43 1.56 0 2.99-.56 4.1-1.48l1.05-.83c3.01-2.64 6.96-4.23 11.28-4.23 9.46 0 17.14 7.73 17.14 17.2 0 9.47-7.68 17.08-17.14 17.08-4.32 0-8.27-1.59-11.28-4.23l-1.05-.83a6.41 6.41 0 00-4.1-1.48c-3.55 0-6.43 2.88-6.43 6.43v34.76C0 159.22 4.45 164 9.95 164h7.47l60.78-60.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "url(#c)",
    d: "M128 52.4v-2.68c0-5.5-4.45-9.72-9.95-9.72H81.03c-3.55 0-6.43-2.77-6.43-6.32 0-1.56.56-3.1 1.48-4.21l.83-1.05c2.64-3.01 4.23-6.96 4.23-11.28C81.14 7.68 73.47 0 64 0S46.86 7.69 46.86 17.15c0 4.32 1.59 8.28 4.23 11.29l.83 1.08c.92 1.11 1.48 2.6 1.48 4.16 0 3.55-2.88 6.32-6.43 6.32H15.99l62.21 62.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "url(#d)",
    d: "M16.4 164h101.65c5.5 0 9.95-4.78 9.95-10.28v-1.71L78.2 102.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128 49.72v104c0 5.5-4.45 10.28-9.95 10.28H9.95C4.45 164 0 159.22 0 153.72v-34.76c0-3.55 2.88-6.43 6.43-6.43 1.56 0 2.99.56 4.1 1.48l1.05.83c3.01 2.64 6.96 4.23 11.28 4.23 9.46 0 17.14-7.61 17.14-17.08 0-9.47-7.68-17.2-17.14-17.2-4.32 0-8.27 1.59-11.28 4.23l-1.05.83a6.41 6.41 0 01-4.1 1.48C2.88 91.33 0 88.45 0 84.9V49.72C0 44.22 4.45 40 9.95 40h37.02c3.55 0 6.43-2.77 6.43-6.32 0-1.56-.56-3.05-1.48-4.16l-.83-1.08a17.07 17.07 0 01-4.23-11.29C46.86 7.69 54.53 0 64 0s17.14 7.68 17.14 17.14c0 4.32-1.59 8.27-4.23 11.28l-.83 1.05c-.92 1.11-1.48 2.65-1.48 4.21 0 3.55 2.88 6.32 6.43 6.32h37.02c5.5 0 9.95 4.22 9.95 9.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#FFF",
    opacity: 0.25,
    d: "M64 1c9.31 0 16.86 7.43 17.12 16.66.01-.18.02-.35.02-.52C81.14 7.68 73.47 0 64 0S46.86 7.69 46.86 17.15c0 .18.02.35.02.52C47.14 8.44 54.69 1 64 1zM9.95 41h37.02c3.55 0 6.43-2.77 6.43-6.32 0-.12-.03-.24-.03-.36-.32 3.24-3.07 5.68-6.4 5.68H9.95C4.45 40 0 44.22 0 49.72v1C0 45.22 4.45 41 9.95 41zm-3.52 72.53c1.56 0 2.99.56 4.1 1.48l1.05.83c3.01 2.64 6.96 4.23 11.28 4.23 9.46 0 17.14-7.61 17.14-17.08 0-.17-.02-.33-.03-.5-.27 9.23-7.82 16.58-17.11 16.58-4.32 0-8.27-1.59-11.28-4.23l-1.05-.83a6.41 6.41 0 00-4.1-1.48c-3.55 0-6.43 2.88-6.43 6.43v1c0-3.55 2.88-6.43 6.43-6.43zM118.05 40H81.03c-3.34 0-6.08-2.45-6.4-5.69-.01.12-.03.24-.03.37 0 3.55 2.88 6.32 6.43 6.32h37.02c5.5 0 9.95 4.22 9.95 9.72v-1c0-5.5-4.45-9.72-9.95-9.72z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "#231F20"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M51.92 29.52c.85 1.02 1.37 2.37 1.45 3.8a6.575 6.575 0 00-1.45-4.8l-.83-1.08c-2.53-2.89-4.08-6.65-4.21-10.77 0 .16-.02.31-.02.48 0 4.32 1.59 8.28 4.23 11.29zm24.16-1.05c-.92 1.11-1.48 2.65-1.48 4.21 0 .21.01.43.03.63.08-1.43.6-2.82 1.45-3.84l.83-1.05c2.64-3.01 4.23-6.96 4.23-11.28 0-.16-.02-.32-.02-.48-.12 4.11-1.67 7.87-4.21 10.76zM6.43 91.33c1.56 0 2.99-.56 4.1-1.48l1.05-.83c3.01-2.64 6.96-4.23 11.28-4.23 9.29 0 16.85 7.46 17.11 16.7 0-.17.03-.33.03-.5 0-9.47-7.68-17.2-17.14-17.2-4.32 0-8.27 1.59-11.28 4.23l-1.05.83a6.41 6.41 0 01-4.1 1.48C2.88 90.33 0 87.45 0 83.9v1c0 3.55 2.88 6.43 6.43 6.43z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M118.05 163H17.4l-1 1h101.65c5.5 0 9.95-4.78 9.95-10.28v-1c0 5.5-4.45 10.28-9.95 10.28z"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M9.95 163C4.45 163 0 158.22 0 152.72v1C0 159.22 4.45 164 9.95 164h6.45l1-1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon4);
export default __webpack_public_path__ + "static/media/nav-icon4.118d0d37abe3f7c863d3d0c676795beb.svg";
export { ForwardRef as ReactComponent };